import { FASTElement, customElement } from '@microsoft/fast-element';
import { visuallyHiddenTemplate } from './template.js';
import { visuallyHiddenStyles } from './styles.js';

@customElement({
	name: 'visually-hidden',
	template: visuallyHiddenTemplate,
	styles: visuallyHiddenStyles
})
export class VisuallyHidden extends FASTElement {}